<!-- p89 TrumpCard-wordー-をもじって、表に意味、裏面に単語を固定順に表示 Feb10-->
<!-- コメントたりとも全角空白はエラーとなる -->
<template>
    <div id="app"> 
        <!-- <FlexScreen/> -->
        <WordCard  v-show="true" 
            v-for="(c,index) in cards"
            :key="index"
            :jWord="c.jWord"
            :eWord="c.eWord"
            :index="index"
        ></WordCard>

    </div>
</template>
<script>
// import FlexScreen from "./components/FlexScreen.vue";
import WordCard from "./components/WordCardejPronFnt2.vue";
// componentのファイル名と、importされた変数名は揃えた方がわかりやすい

export default {
    name: "App",
    components:{
        WordCard,
        // FlexScreen,
    },
    data() {
        return {
            cards: [],
        };
    },
    created(){
        var jWords ="猫,捕まえる,帽子,手,サラダ,土地,ビニールの,計画・計画する,男・人,立つ".split(",");
        var eWords="cat,catch,hat,hand,salad,land,plastic,plan,man,stand".split(",");
        // var temp=[];
        this.cards=[];
            for (var j=0;j<jWords.length;j++){
                this.cards.push({jWord: jWords[j], eWord:eWords[j]});
            }

        // while (temp.length >0 ) {
        //     var r= Math.floor(Math.random() * temp.length);
        //     this.cards.push(temp[r]);
        //     temp.splice(r,1);
        // }
    },
};
</script>